import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/shop/reports/customer'

export default {
  async getAll(filter) {
    return await axios
      .get(`${endpoint}/list${filter}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async exportToExcel(request) {
    return await axios
      .post(`${endpoint}/export/xls`, request)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw error.response.data
      });
  },
}



// WEBPACK FOOTER //
// ./src/services/shop/report/customerReportService.js